import React from "react";
import SEO from "../components/SEO";
import CTASection from "../components/CTASection";

const ContactPage = () => {
  return (
    <>
      <SEO
        title="Contact Us | Global Trademark Filer - Get Your Free Consultation"
        description="Contact Global Trademark Filer for expert trademark registration assistance. Free consultation, licensed USPTO attorneys, fast response time."
        keywords="contact trademark attorney, trademark consultation, USPTO filing help, trademark registration contact"
        canonical="/contact"
      />
      <div className="min-h-screen bg-gray-50">
        <div className="py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Get Your Free Trademark Consultation
            </h1>
            <p className="text-xl text-gray-600">
              Have questions? Our trademark experts are ready to help. Fill out
              the form below and we'll get back to you within 24 hours.
            </p>
          </div>
          <CTASection />
        </div>

        <section className="bg-white py-16" aria-label="Contact information">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center mb-12">
              Other Ways to Reach Us
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-[#168356]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-8 h-8 text-[#168356]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2">Email</h3>
                <a
                  href="mailto:Info@globaltrademarkfiler.com"
                  className="text-[#168356] hover:underline"
                >
                  Info@globaltrademarkfiler.com
                </a>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-[#168356]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-8 h-8 text-[#168356]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2">Phone</h3>
                <a
                  href="tel:+18886690240"
                  className="text-[#168356] hover:underline"
                >
                  +1 (213) 973-3050
                </a>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-[#168356]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-8 h-8 text-[#168356]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2">Address</h3>
                <p className="text-gray-600">
                  453 S Spring St
                  <br />
                  Los Angeles, CA 90013
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ContactPage;
